module.exports = __webpack_public_path__ + "static/AxiomSL-1236d8de0ae0826897e955919824096c.jpg";